/* ==========================================================================
   Goldtop, 26 September 2026
   The position rail under the mobile "Pairs well with" carousel.

   The track itself is pure CSS - a scroll-snapping flex row. This file only
   drives the indicator under it: how wide the thumb is (the share of the
   track on screen) and where it sits (how far through the scroll you are).

   Re-initialised from a MutationObserver because product-recommendations
   replaces its own contents from a section fetch when it scrolls into view;
   anything bound at load would be pointing at discarded nodes afterwards.
   ========================================================================== */
(function () {
  if (window.__gtRecCarousel) return;
  window.__gtRecCarousel = true;

  var MQ = '(max-width: 768px)';
  var MIN_THUMB = 24;

  /* The custom element, not the .product-recommendations class: the theme's
     own section-fetch re-render drops that wrapper and leaves the track inside
     .product-recommendations-placeholder, so the class is not on the page once
     the real cards arrive. The element always is. */
  function railFor(track) {
    var host = track.closest('product-recommendations');
    return host ? host.querySelector('[data-gt-rec-rail]') : null;
  }

  function sync(track) {
    var rail = railFor(track);
    if (!rail) return;

    var overflow = track.scrollWidth - track.clientWidth;
    var on = window.matchMedia(MQ).matches && overflow > 2;
    rail.classList.toggle('is-on', on);
    if (!on) return;

    var thumb = rail.querySelector('[data-gt-rec-rail-thumb]');
    if (!thumb) return;

    var railWidth = rail.clientWidth;
    if (!railWidth) return;

    var width = Math.max(MIN_THUMB, railWidth * (track.clientWidth / track.scrollWidth));
    var travel = railWidth - width;
    var offset = travel > 0 ? (track.scrollLeft / overflow) * travel : 0;

    thumb.style.width = width + 'px';
    thumb.style.transform = 'translateX(' + offset + 'px)';
  }

  function bind(track) {
    if (!track.__gtRecBound) {
      track.__gtRecBound = true;
      track.addEventListener('scroll', function () {
        if (track.__gtRecTick) return;
        track.__gtRecTick = true;
        requestAnimationFrame(function () {
          track.__gtRecTick = false;
          sync(track);
        });
      }, { passive: true });
    }
    sync(track);
  }

  function init() {
    var tracks = document.querySelectorAll('product-recommendations .product-single__related');
    for (var i = 0; i < tracks.length; i++) bind(tracks[i]);
  }

  var pending;
  function refresh() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(init, 80);
  }

  function watch() {
    var hosts = document.querySelectorAll('product-recommendations');
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].__gtRecObserved) continue;
      hosts[i].__gtRecObserved = true;
      new MutationObserver(refresh).observe(hosts[i], { childList: true, subtree: true });
    }
  }

  function boot() {
    init();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
  window.addEventListener('resize', refresh);
  window.addEventListener('orientationchange', refresh);
})();
